import { useLocation } from "wouter";
import { useTranslation } from "react-i18next";
import { BarChart3, Target, ClipboardList, FolderOpen, Sparkles, ArrowLeft, Users } from "lucide-react";
import { Button } from "@/components/ui/button";

const DEALERSHIP_ITEMS = [
  {
    title: "Dealer Profile & Goals",
    titleKey: "nav:dealerProfileGoals",
    descKey: "nav:dealershipHub.profileGoalsDesc",
    icon: Target,
    href: "/sla",
    color: "text-violet-400",
    bg: "bg-violet-500/15",
  },
  {
    title: "Performance Assessment",
    titleKey: "nav:performanceAssessment",
    descKey: "nav:dealershipHub.assessmentDesc",
    icon: ClipboardList,
    href: "/operations?tab=assessment",
    color: "text-violet-400",
    bg: "bg-violet-500/15",
  },
  {
    title: "Documents",
    titleKey: "nav:documents",
    descKey: "nav:dealershipHub.documentsDesc",
    icon: FolderOpen,
    href: "/documents",
    color: "text-violet-400",
    bg: "bg-violet-500/15",
  },
  {
    title: "Dean Chats",
    titleKey: "nav:deanChats",
    descKey: "nav:dealershipHub.deanChatsDesc",
    icon: Sparkles,
    href: "/dean",
    color: "text-violet-400",
    bg: "bg-violet-500/15",
  },
  {
    title: "Lot Talk",
    titleKey: "nav:lotTalk",
    descKey: "nav:dealershipHub.lotTalkDesc",
    icon: Users,
    href: "/dealer-social",
    color: "text-violet-400",
    bg: "bg-violet-500/15",
  },
];

export default function DealershipHubPage() {
  const [, navigate] = useLocation();
  const { t } = useTranslation(["nav", "common"]);

  return (
    <div className="min-h-full bg-black flex flex-col items-center px-4 py-10">
      <div className="w-full max-w-2xl space-y-8">
        <div>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate("/hub")}
            data-testid="button-back-to-hub"
            className="gap-1.5 text-white/40 hover:text-white/70 hover:bg-white/5"
          >
            <ArrowLeft className="w-4 h-4" />
            {t("nav:hub")}
          </Button>
        </div>

        <div className="flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-violet-500/15 border border-violet-500/30 flex items-center justify-center">
            <BarChart3 className="w-6 h-6 text-violet-400" />
          </div>
          <div>
            <p className="text-xs font-semibold uppercase tracking-widest text-white/40">{t("nav:dealershipHub.subtitle")}</p>
            <h1 className="text-2xl font-bold tracking-tight text-white">{t("nav:dealershipAtAGlance")}</h1>
          </div>
        </div>

        <p className="text-white/50 text-sm">
          {t("nav:dealershipHub.intro")}
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          {DEALERSHIP_ITEMS.map((item) => (
            <button
              key={item.href}
              type="button"
              data-testid={`dealership-nav-${item.title.toLowerCase().replace(/\s+/g, "-")}`}
              onClick={() => navigate(item.href)}
              className="flex items-start gap-4 p-4 rounded-xl border border-white/10 bg-white/5 text-left hover:border-violet-500/40 hover:bg-white/8 transition-all group"
            >
              <div className={`w-10 h-10 rounded-lg flex items-center justify-center shrink-0 ${item.bg} transition-transform group-hover:scale-105`}>
                <item.icon className={`w-5 h-5 ${item.color}`} />
              </div>
              <div className="min-w-0">
                <p className="font-semibold text-sm text-white">{t(item.titleKey)}</p>
                <p className="text-xs text-white/45 mt-0.5 leading-relaxed">{t(item.descKey)}</p>
              </div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
